export class ClasseMaterial {
  codigoGrupo: number;
  nomeGrupo: string;
  codigoClasse: number;
  nomeClasse: string;
  statusClasse: boolean;
}
